// removed by extract-text-webpack-plugin
module.exports = {"busy":"WaitButton-busy"};